/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// ----------------------------------------------------------------------

import Router from 'src/routes/sections';

import ThemeProvider from 'src/theme';

import { AuthProvider } from 'src/auth/context';
import LocalizationProvider from './components/locales/localization-provider';
import { SnackbarProvider } from './components/snackbar';
import { StoreProvider } from './store';
import RealtimeDatabaseProvider from './components/realtime-database/realtime-database-provider';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <StoreProvider>
      <AuthProvider>
        <RealtimeDatabaseProvider>
          <LocalizationProvider>
            <ThemeProvider>
              <SnackbarProvider>
                <Router />
              </SnackbarProvider>
            </ThemeProvider>
          </LocalizationProvider>
        </RealtimeDatabaseProvider>
      </AuthProvider>
    </StoreProvider>
  );
}
